import dynamic from 'next/dynamic';
import { ContentDetailMetricsContentType } from '~/components/ContentDetailMetrics';
import { SOCIAL_PLATFORMS } from '~/constants';

const InstagramContentCard = dynamic(
  () => import('~/components/ContentFullCard'),
);
const TiktokContentCard = dynamic(() =>
  import('~/components/TiktokContentCard').then(
    ({ TiktokContentCard }) => TiktokContentCard,
  ),
);
const YoutubeContentCard = dynamic(
  () => import('~/components/YoutubeVideoPlayer'),
);

export interface ContentAssetProps {
  content: ContentDetailMetricsContentType;
  trackId: string;
}

export const Asset = ({ content, trackId }: ContentAssetProps) => {
  const ContentCard = {
    [SOCIAL_PLATFORMS.instagram]: InstagramContentCard,
    [SOCIAL_PLATFORMS.tiktok]: TiktokContentCard,
    [SOCIAL_PLATFORMS.youtube]: YoutubeContentCard,
  }[content.platform];
  return <ContentCard content={content as any} trackId={trackId} />;
};
